<template>
    <v-container fluid v-if="commessa">
        <v-row class="align-center mb-2">
            <v-col cols="auto">
                <h2 class="text-h6">Commessa {{ commessa.numero }} <span class="text-medium-emphasis">— prog.
                        {{ commessa.progressivo }}</span></h2>
            </v-col>
            <v-col v-if="isAdmin" cols="auto">
                <v-btn icon variant="text" size="small" @click="apriDialogCommessa" title="Modifica commessa">
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon variant="text" size="small" color="error" @click="confermaEliminaCommessa = true"
                    title="Elimina commessa">
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
            </v-col>
        </v-row>

        <v-card variant="outlined" class="mb-4">
            <v-card-text>
                <v-row dense>
                    <v-col cols="6" sm="3">
                        <div class="text-caption text-medium-emphasis">Cliente</div>
                        <div>{{ commessa.cliente }}</div>
                        <div class="text-caption">{{ indirizzoCliente }}</div>
                    </v-col>
                    <v-col cols="6" sm="2">
                        <div class="text-caption text-medium-emphasis">Data</div>
                        <div>{{ formattaData(commessa.data) }}</div>
                    </v-col>
                    <v-col cols="6" sm="2">
                        <div class="text-caption text-medium-emphasis">Lotto</div>
                        <div>{{ commessa.lotto || '—' }}</div>
                    </v-col>
                    <v-col cols="6" sm="5">
                        <div class="text-caption text-medium-emphasis">Cantiere</div>
                        <div>{{ commessa.cantiere || '—' }}</div>
                        <div class="text-caption">{{ indirizzoCantiere }}</div>
                        <div v-if="commessa.cantiereZona" class="text-caption">
                            Zona climatica {{ commessa.cantiereZona }} — gradi giorno {{ commessa.cantiereGrg ?? '—' }}
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <v-row class="align-center mb-2">
            <v-col cols="auto">
                <h3 class="text-subtitle-1">Posizioni</h3>
            </v-col>
            <v-spacer />
            <v-col v-if="isAdmin" cols="auto">
                <v-btn color="primary" prepend-icon="mdi-plus" @click="apriDialogPosizione(null)">Nuova
                    posizione</v-btn>
            </v-col>
        </v-row>

        <v-data-table :headers="headersPosizioni" :items="posizioni" :items-per-page="25" density="compact">
            <template #[`item.disegno`]="{ item }">
                <div class="disegno-miniatura">
                    <DisegnoSerramentoSvg compatto :forma="formaDi(item.tipoDisegnoId)" :l="item.l" :h="item.h"
                        :corda="item.corda" :battenti="item.battenti" :nr-riempimenti="item.nrRiempimenti" />
                </div>
            </template>
            <template #[`item.uw`]="{ item }">
                <div class="d-flex align-center" style="gap: 6px">
                    <v-img :src="uwPlaceholder" width="20" height="30" />
                    <span :class="{ 'text-error font-weight-bold': item.uw > 1.3 }">{{ item.uw ?? '' }}</span>
                </div>
            </template>
            <template #[`item.azioni`]="{ item }">
                <div class="d-flex flex-nowrap azioni-posizione">
                    <v-btn icon variant="text" size="small" color="primary" @click="apriTrasmittanza(item)"
                        title="Calcolo trasmittanza">
                        <v-icon>mdi-calculator-variant</v-icon>
                    </v-btn>
                    <v-btn icon variant="text" size="small" @click="apriDialogPosizione(item)"
                        :title="isAdmin ? 'Modifica' : 'Visualizza'">
                        <v-icon>{{ isAdmin ? 'mdi-pencil' : 'mdi-eye' }}</v-icon>
                    </v-btn>
                    <v-btn v-if="isAdmin" icon variant="text" size="small" @click="duplicaPosizione(item)"
                        title="Duplica">
                        <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                    <v-btn v-if="isAdmin" icon variant="text" size="small" color="error"
                        @click="posizioneDaEliminare = item" title="Elimina">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </div>
            </template>
        </v-data-table>

        <!-- Dialog modifica dati commessa -->
        <v-dialog v-model="dialogCommessa" max-width="760" :fullscreen="isMobile">
            <v-card>
                <v-card-title>Modifica commessa</v-card-title>
                <v-card-text>
                    <CommessaForm ref="commessaForm" v-model="formCommessa" />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="dialogCommessa = false">Annulla</v-btn>
                    <v-btn color="primary" :loading="salvandoCommessa" @click="salvaCommessa">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Conferme di eliminazione -->
        <v-dialog v-model="confermaEliminaCommessa" max-width="440">
            <v-card>
                <v-card-title>Eliminare la commessa?</v-card-title>
                <v-card-text>Verranno eliminate anche tutte le sue posizioni.</v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="confermaEliminaCommessa = false">Annulla</v-btn>
                    <v-btn color="error" @click="eliminaCommessa">Elimina</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog :model-value="!!posizioneDaEliminare" max-width="420"
            @update:model-value="posizioneDaEliminare = null">
            <v-card>
                <v-card-title>Eliminare la posizione {{ posizioneDaEliminare?.rif }}?</v-card-title>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="posizioneDaEliminare = null">Annulla</v-btn>
                    <v-btn color="error" @click="eliminaPosizione">Elimina</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog visualizza/modifica posizione -->
        <v-dialog v-model="dialogPosizione" max-width="980" :fullscreen="isMobile">
            <v-card>
                <v-card-title>
                    {{ posizioneCorrente.id ? `Posizione ${posizioneCorrente.rif}` : 'Nuova posizione' }}
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="4">
                            <!-- Anteprima schematica generata dai parametri (non è il disegno CAD). -->
                            <div class="disegno-box">
                                <DisegnoSerramentoSvg :forma="tipoDisegnoSelezionato?.codice" :l="formPosizione.l"
                                    :h="formPosizione.h" :corda="formPosizione.corda"
                                    :battenti="formPosizione.battenti" :nr-riempimenti="formPosizione.nrRiempimenti" />
                            </div>
                        </v-col>
                        <v-col cols="12" sm="8">
                            <v-form ref="formPosizioneRef" :disabled="!isAdmin">
                                <v-row dense>
                                    <v-col cols="8">
                                        <v-autocomplete v-model="formPosizione.progettoId" :items="progettiConLabel"
                                            item-title="label" item-value="id" label="Progetto"
                                            :rules="[v => !!v || 'Obbligatorio']"
                                            @update:model-value="onProgettoCambiato" />
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field :model-value="pfSelezionato" label="P/F" readonly />
                                    </v-col>
                                </v-row>
                                <v-text-field v-model="formPosizione.descrizione" label="Descrizione"
                                    :rules="[v => !!v || 'Obbligatorio']" />
                                <v-row dense>
                                    <v-col cols="4">
                                        <v-text-field v-model.number="formPosizione.qta" type="number" label="Qta"
                                            :rules="[v => v > 0 || 'Obbligatorio']" />
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field v-model.number="formPosizione.battenti" type="number"
                                            label="Battenti (BATT)" @update:model-value="onBattentiCambiato" />
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field v-model.number="formPosizione.hMan" type="number"
                                            label="H. Maniglia (mm)" />
                                    </v-col>
                                </v-row>
                                <v-select v-model="formPosizione.aperturaId" :items="aperturePerPosizione"
                                    item-title="descrizione" item-value="id" label="Apertura" clearable
                                    :no-data-text="progettoSelezionato ? 'Nessuna apertura per questa tipologia/battenti' : 'Seleziona prima il progetto'" />
                                <v-row dense>
                                    <v-col cols="6" sm="3">
                                        <v-text-field v-model.number="formPosizione.l" type="number" step="0.1"
                                            label="L (mm)" :rules="[v => v > 0 || 'Obbligatorio']" />
                                    </v-col>
                                    <v-col cols="6" sm="3">
                                        <v-text-field v-model.number="formPosizione.h" type="number" step="0.1"
                                            label="H (mm)" :rules="[v => v > 0 || 'Obbligatorio']" />
                                    </v-col>
                                    <v-col cols="6" sm="3">
                                        <v-text-field v-model.number="formPosizione.spessore" type="number"
                                            step="0.1" label="Spessore (mm)" />
                                    </v-col>
                                    <v-col cols="6" sm="3">
                                        <v-text-field v-model.number="formPosizione.corda" type="number" step="0.1"
                                            label="Corda / arco (mm)" />
                                    </v-col>
                                </v-row>

                                <v-select v-model="formPosizione.tipoDisegnoId" :items="tipiDisegno"
                                    item-title="descrizione" item-value="id" label="Tipo disegno" clearable
                                    @update:model-value="onTipoDisegnoCambiato" />
                                <v-row v-if="parametriDelTipo.length" dense>
                                    <v-col v-for="p in parametriDelTipo" :key="p.id" cols="6">
                                        <v-text-field v-model.number="parametriValori[p.id]" type="number" step="0.1"
                                            :label="p.etichetta" />
                                    </v-col>
                                </v-row>

                                <div class="text-caption text-medium-emphasis font-weight-medium mt-2 mb-1">
                                    Materiali per il calcolo della trasmittanza
                                </div>
                                <v-row dense>
                                    <v-col cols="12" sm="6">
                                        <v-autocomplete v-model="formPosizione.legnoArticoloId"
                                            :items="articoliLegno" item-title="label" item-value="id" label="Legno"
                                            clearable />
                                    </v-col>
                                    <v-col cols="6" sm="3">
                                        <v-select v-model="formPosizione.nrRiempimenti" :items="[1, 2, 3]"
                                            label="Riempimenti" />
                                    </v-col>
                                    <v-col cols="6" sm="3">
                                        <v-text-field v-model.number="formPosizione.vanoVetro" type="number"
                                            label="Vano vetro (mm)" />
                                    </v-col>
                                </v-row>
                                <v-autocomplete v-model="formPosizione.vetroSupArticoloId" :items="articoliRiempimento"
                                    item-title="label" item-value="id" label="Riempimento superiore (vetro/pannello)"
                                    clearable />
                                <v-autocomplete v-if="formPosizione.nrRiempimenti === 3"
                                    v-model="formPosizione.vetroIntArticoloId" :items="articoliRiempimento"
                                    item-title="label" item-value="id" label="Riempimento intermedio" clearable />
                                <v-autocomplete v-if="formPosizione.nrRiempimenti >= 2"
                                    v-model="formPosizione.vetroInfArticoloId" :items="articoliRiempimento"
                                    item-title="label" item-value="id" label="Riempimento inferiore" clearable />

                                <div class="text-caption text-medium-emphasis font-weight-medium mt-2 mb-1">
                                    Nodi del telaio e prestazioni
                                </div>
                                <v-checkbox v-model="formPosizione.traversoIntermedio" density="compact" hide-details
                                    label="Traverso intermedio (aggiunge il nodo traverso centrale)" />
                                <v-row dense>
                                    <v-col cols="12" sm="4">
                                        <v-select v-model="formPosizione.opzione001" :items="opzioni001"
                                            label="Opzione 001" density="compact" />
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                        <v-select v-model="formPosizione.opzione009" :items="opzioni009"
                                            label="Profilo (opzione 009)" density="compact" />
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                        <v-select v-model="formPosizione.opzione010" :items="opzioni010"
                                            label="Nodo centrale (opzione 010)" density="compact" />
                                    </v-col>
                                </v-row>

                                <v-textarea v-model="formPosizione.note" label="Note" rows="2" auto-grow />
                            </v-form>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="dialogPosizione = false">{{ isAdmin ? 'Annulla' : 'Chiudi'
                    }}</v-btn>
                    <v-btn v-if="isAdmin" color="primary" :loading="salvandoPosizione"
                        @click="salvaPosizione">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Videata di calcolo trasmittanza (UNI EN ISO 10077-1/-2) -->
        <TrasmittanzaPosizione v-model="dialogTrasmittanza" :commessa-id="id" :posizione="posizioneTrasmittanza"
            :puo-modificare="isAdmin" :articoli="articoli" :luogo="luogoCantiere" @salvato="onTrasmittanzaSalvata" />
    </v-container>
    <v-container v-else>
        <v-progress-circular indeterminate color="primary" />
    </v-container>
</template>

<script>
import uwPlaceholder from "@/assets/uw-rating-placeholder.svg";
import CommessaForm from "@/components/commesse/CommessaForm.vue";
import TrasmittanzaPosizione from "@/components/commesse/TrasmittanzaPosizione.vue";
import DisegnoSerramentoSvg from "@/components/commesse/DisegnoSerramentoSvg.vue";
import { anagrafica_lista } from "@/api/api.anagrafiche.js";

export default {
    name: "CommessaDettaglioPage",
    components: { CommessaForm, TrasmittanzaPosizione, DisegnoSerramentoSvg },

    props: {
        id: { type: [String, Number], required: true },
    },

    data() {
        return {
            uwPlaceholder,
            dialogCommessa: false,
            salvandoCommessa: false,
            formCommessa: this.formCommessaVuoto(),
            confermaEliminaCommessa: false,
            posizioneDaEliminare: null,
            dialogPosizione: false,
            salvandoPosizione: false,
            posizioneCorrente: {},
            formPosizione: this.formPosizioneVuoto(),
            dialogTrasmittanza: false,
            posizioneTrasmittanza: null,
            articoli: [],
            // Valori dei parametri geometrici del tipo disegno scelto, tenuti a parte
            // (mappa parametroDisegnoId -> valore) perché il set di campi è dinamico.
            parametriValori: {},
            // Opzioni del configuratore VB che cambiano i nodi del telaio e le prestazioni.
            opzioni001: [
                { title: "Nessuna", value: "" },
                { title: "04 — Tenuta non dichiarata (aria CLASSE 1, acqua e vento NPD)", value: "04" },
                { title: "05 — Nodo inferiore finestra tipo 05", value: "05" },
            ],
            opzioni009: [
                { title: "Nessuna", value: "" },
                { title: "04 — Epoque (larghezze LNodoEpoque)", value: "04" },
            ],
            opzioni010: [
                { title: "Nessuna (nodo 06)", value: "" },
                { title: "03 — Nodo centrale 07", value: "03" },
                { title: "04 — Nodo centrale 08", value: "04" },
                { title: "05 — Nodo centrale 08", value: "05" },
                { title: "06 — Nodo centrale 08", value: "06" },
                { title: "07 — Nodo centrale 08", value: "07" },
            ],
            headersPosizioni: [
                { title: "Rif", key: "rif", width: 70 },
                { title: "Progetto", key: "codProgetto" },
                { title: "Descrizione", key: "descrizione" },
                { title: "Qta", key: "qta" },
                { title: "P/F", key: "pf" },
                { title: "BATT", key: "battenti" },
                { title: "H.Man", key: "hMan" },
                { title: "Apertura", key: "aperturaDescrizione" },
                { title: "L", key: "l" },
                { title: "H", key: "h" },
                { title: "Spess.", key: "spessore" },
                { title: "", key: "disegno", sortable: false, width: 60 },
                { title: "Uw", key: "uw", sortable: false, width: 90 },
                { title: "", key: "azioni", sortable: false, width: 170 },
            ],
        };
    },

    computed: {
        isMobile() {
            return this.$vuetify.display.smAndDown;
        },
        commessa() {
            return this.$store.getters["commesse/corrente"];
        },
        posizioni() {
            return this.$store.getters["commesse/posizioni"];
        },
        isAdmin() {
            const ruolo = this.$store.getters["user/getRole"];
            return ruolo === "Admin" || ruolo === "SuperAdmin";
        },

        indirizzoCliente() {
            const c = this.commessa;
            return [c.clienteIndirizzo, [c.clienteCap, c.clienteCitta].filter(Boolean).join(" "), c.clienteProv]
                .filter(Boolean).join(", ");
        },
        indirizzoCantiere() {
            const c = this.commessa;
            const comune = [c.cantiereCap, c.cantiereCitta].filter(Boolean).join(" ");
            return [c.cantiereIndirizzo, comune, c.cantiereProv ? `(${c.cantiereProv})` : ""].filter(Boolean).join(", ");
        },

        luogoCantiere() {
            const c = this.commessa;
            if (!c) return "";
            return [c.cantiereCitta, c.cantiereProv ? `(${c.cantiereProv})` : ""].filter(Boolean).join(" ");
        },

        progetti() {
            return this.$store.getters["progetti/lista"];
        },
        // v-autocomplete ha bisogno di un'etichetta testuale unica per voce.
        progettiConLabel() {
            return this.progetti.map(p => ({ ...p, label: `${p.codProgetto} — ${p.descrizione}` }));
        },
        articoliLegno() {
            return this.articoliPerCategoria(["LEGNO"]);
        },
        articoliRiempimento() {
            return this.articoliPerCategoria(["VETRO", "PANNELLO"]);
        },
        tipiDisegno() {
            return this.$store.getters["tipiDisegno/lista"];
        },
        tutteLeAperture() {
            return this.$store.getters["aperture/lista"];
        },

        progettoSelezionato() {
            return this.progetti.find(p => p.id === this.formPosizione.progettoId) || null;
        },
        pfSelezionato() {
            return this.progettoSelezionato ? this.progettoSelezionato.pf : "";
        },
        // Solo le aperture coerenti con la tipologia del progetto scelto e il numero
        // di battenti impostato in posizione.
        aperturePerPosizione() {
            if (!this.progettoSelezionato) return [];
            return this.tutteLeAperture.filter(a =>
                a.tipoSerramentoId === this.progettoSelezionato.tipoSerramentoId &&
                a.numBattenti === this.formPosizione.battenti);
        },
        tipoDisegnoSelezionato() {
            return this.tipiDisegno.find(t => t.id === this.formPosizione.tipoDisegnoId) || null;
        },
        parametriDelTipo() {
            return this.tipoDisegnoSelezionato ? this.tipoDisegnoSelezionato.parametri : [];
        },
    },

    mounted() {
        this.carica();
        this.$store.dispatch("progetti/carica");
        this.$store.dispatch("tipiDisegno/carica");
        this.$store.dispatch("aperture/carica");
        this.caricaArticoli();
    },

    methods: {
        carica() {
            this.$store.dispatch("commesse/caricaDettaglio", this.id);
            this.$store.dispatch("commesse/caricaPosizioni", this.id);
        },

        async caricaArticoli() {
            try {
                const resp = await anagrafica_lista("articoli");
                this.articoli = resp.data;
            } catch (error) {
                console.log(error);
            }
        },

        articoliPerCategoria(categorie) {
            return this.articoli
                .filter(a => categorie.includes(a.categoria))
                .map(a => ({ ...a, label: `${a.codArticolo}${a.descrizione ? " — " + a.descrizione : ""}` }));
        },

        // v-model.number lascia "" nei campi svuotati: per il backend i numeri opzionali devono essere null.
        numeroOpzionale(v) {
            return v === "" || v === null || v === undefined ? null : Number(v);
        },

        formattaData(iso) {
            return iso ? new Date(iso).toLocaleDateString("it-IT") : "—";
        },

        formCommessaVuoto() {
            return {
                numero: "", cliente: "", data: "", lotto: "",
                clienteIndirizzo: "", clienteCap: "", clienteCitta: "", clienteProv: "",
                cantiere: "", cantiereIndirizzo: "", cantiereCap: "", cantiereCitta: "", cantiereProv: "",
                cantiereComuneId: null,
            };
        },

        apriDialogCommessa() {
            const c = this.commessa;
            this.formCommessa = {
                numero: c.numero,
                cliente: c.cliente,
                data: c.data ? c.data.substring(0, 10) : "",
                lotto: c.lotto || "",
                clienteIndirizzo: c.clienteIndirizzo || "",
                clienteCap: c.clienteCap || "",
                clienteCitta: c.clienteCitta || "",
                clienteProv: c.clienteProv || "",
                cantiere: c.cantiere || "",
                cantiereIndirizzo: c.cantiereIndirizzo || "",
                cantiereCap: c.cantiereCap || "",
                cantiereCitta: c.cantiereCitta || "",
                cantiereProv: c.cantiereProv || "",
                cantiereComuneId: c.cantiereComuneId,
            };
            this.dialogCommessa = true;
        },

        async salvaCommessa() {
            if (!(await this.$refs.commessaForm.validate())) return;
            this.salvandoCommessa = true;
            try {
                await this.$store.dispatch("commesse/aggiorna", { id: this.id, dati: this.formCommessa });
                this.dialogCommessa = false;
            } catch (error) {
                console.log(error);
            }
            this.salvandoCommessa = false;
        },

        async eliminaCommessa() {
            this.confermaEliminaCommessa = false;
            try {
                await this.$store.dispatch("commesse/elimina", this.id);
                this.$router.push({ path: "/" });
            } catch (error) {
                console.log(error);
            }
        },

        async eliminaPosizione() {
            const item = this.posizioneDaEliminare;
            this.posizioneDaEliminare = null;
            if (!item) return;
            try {
                await this.$store.dispatch("commesse/eliminaPosizione", { commessaId: this.id, id: item.id });
                this.$store.dispatch("commesse/caricaDettaglio", this.id);
            } catch (error) {
                console.log(error);
            }
        },

        async duplicaPosizione(item) {
            try {
                await this.$store.dispatch("commesse/duplicaPosizione", { commessaId: this.id, id: item.id });
                this.$store.dispatch("commesse/caricaDettaglio", this.id);
            } catch (error) {
                console.log(error);
            }
        },

        // Codice del tipo disegno (RETTANGOLARE, CENTINATO...) da cui dipende la forma dell'anteprima.
        formaDi(tipoDisegnoId) {
            const tipo = this.tipiDisegno.find(t => t.id === tipoDisegnoId);
            return tipo ? tipo.codice : "";
        },

        apriTrasmittanza(item) {
            this.posizioneTrasmittanza = item;
            this.dialogTrasmittanza = true;
        },

        // Il salvataggio aggiorna anche il Uw della posizione: si ricarica la griglia.
        onTrasmittanzaSalvata() {
            this.$store.dispatch("commesse/caricaPosizioni", this.id);
        },

        formPosizioneVuoto() {
            return {
                progettoId: null, descrizione: "", note: "", qta: 1, battenti: 1, hMan: null,
                aperturaId: null, l: null, h: null, spessore: null, corda: null, vanoVetro: null,
                tipoDisegnoId: null, nrRiempimenti: 1, traversoIntermedio: false, opzione001: "", opzione009: "", opzione010: "",
                legnoArticoloId: null, vetroSupArticoloId: null, vetroIntArticoloId: null, vetroInfArticoloId: null,
            };
        },

        // Precompila descrizione, battenti, spessore e vano vetro col default del progetto
        // scelto: restano comunque modificabili dall'utente dopo la selezione.
        onProgettoCambiato(progettoId) {
            const p = this.progetti.find(x => x.id === progettoId);
            if (p) {
                this.formPosizione.descrizione = p.descrizione;
                this.formPosizione.battenti = p.numBattenti;
                if (p.spessore) this.formPosizione.spessore = p.spessore;
                if (p.vanoVetro) this.formPosizione.vanoVetro = p.vanoVetro;
            }
            this.formPosizione.aperturaId = null;
        },

        onBattentiCambiato() {
            this.formPosizione.aperturaId = null;
        },

        onTipoDisegnoCambiato() {
            this.parametriValori = {};
        },

        apriDialogPosizione(item) {
            this.posizioneCorrente = item || {};
            if (item) {
                this.formPosizione = {
                    progettoId: item.progettoId,
                    descrizione: item.descrizione || "",
                    note: item.note || "",
                    qta: item.qta,
                    battenti: item.battenti,
                    hMan: item.hMan,
                    aperturaId: item.aperturaId,
                    l: item.l,
                    h: item.h,
                    spessore: item.spessore,
                    corda: item.corda,
                    vanoVetro: item.vanoVetro,
                    tipoDisegnoId: item.tipoDisegnoId,
                    nrRiempimenti: item.nrRiempimenti || 1,
                    traversoIntermedio: !!item.traversoIntermedio,
                    opzione001: item.opzione001 || "",
                    opzione009: item.opzione009 || "",
                    opzione010: item.opzione010 || "",
                    legnoArticoloId: item.legnoArticoloId,
                    vetroSupArticoloId: item.vetroSupArticoloId,
                    vetroIntArticoloId: item.vetroIntArticoloId,
                    vetroInfArticoloId: item.vetroInfArticoloId,
                };
                this.parametriValori = Object.fromEntries(
                    (item.parametriDisegno || []).map(pd => [pd.parametroDisegnoId, pd.valore]));
            } else {
                this.formPosizione = this.formPosizioneVuoto();
                this.parametriValori = {};
            }
            this.dialogPosizione = true;
        },

        async salvaPosizione() {
            const { valid } = await this.$refs.formPosizioneRef.validate();
            if (!valid) return;
            this.salvandoPosizione = true;
            try {
                const f = this.formPosizione;
                const dati = {
                    ...f,
                    hMan: this.numeroOpzionale(f.hMan),
                    spessore: this.numeroOpzionale(f.spessore),
                    corda: this.numeroOpzionale(f.corda),
                    vanoVetro: this.numeroOpzionale(f.vanoVetro),
                    // Gli articoli dei riempimenti non usati dal numero di riempimenti scelto vengono azzerati.
                    vetroIntArticoloId: f.nrRiempimenti === 3 ? f.vetroIntArticoloId : null,
                    vetroInfArticoloId: f.nrRiempimenti >= 2 ? f.vetroInfArticoloId : null,
                    parametriDisegno: this.parametriDelTipo.map(p => ({
                        parametroDisegnoId: p.id,
                        valore: Number(this.parametriValori[p.id]) || 0,
                    })),
                };
                if (this.posizioneCorrente.id) {
                    await this.$store.dispatch("commesse/aggiornaPosizione", {
                        commessaId: this.id, id: this.posizioneCorrente.id, dati,
                    });
                } else {
                    await this.$store.dispatch("commesse/creaPosizione", {
                        commessaId: this.id, dati,
                    });
                }
                this.dialogPosizione = false;
                this.$store.dispatch("commesse/caricaDettaglio", this.id);
            } catch (error) {
                console.log(error);
            }
            this.salvandoPosizione = false;
        },
    },
};
</script>

<style scoped>
.azioni-posizione {
    min-width: 160px;
}

.disegno-miniatura {
    width: 40px;
    height: 40px;
    padding: 2px;
}

.disegno-box {
    width: 100%;
    height: 260px;
    background: rgba(0, 0, 0, 0.04);
    border: 1px dashed rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    padding: 8px;
}
</style>
